import React from 'react'

const CodeOfEthics = props => {
  let { paragraphs, textLink } = props.ethic
  return <div className='legals__ethic-content'>
    <div className='gray-color' dangerouslySetInnerHTML={{ __html: paragraphs }} />
    <div className='legals__download-btn-container'>
      <a className='legals__download-btn' href={`mailto:contacto@sanfer.com.mx?subject=Código de ética`}>{textLink}</a>
    </div>
  </div>
}

export default CodeOfEthics